import {FC} from 'react';
import {
  UserAvatarWrapper,
  UsersAvatarsBlock,
  UsersBlockWrapper,
} from '@molecules/UsersBlock.styles';
import {IUser} from '@types';
import Text from '@atoms/Text';
import Avatar from '@atoms/Avatar';

export interface UsersBlockProps {
  users?: IUser[];
  systemOwner?: IUser;
  title: string;
}

const UsersBlock: FC<UsersBlockProps> = ({title, users = [], systemOwner}) => {
  const reversedUsers = [...users].reverse();
  return (
    <UsersBlockWrapper>
      <Text text={title} type="tinyM" />
      <UsersAvatarsBlock>
        {!!reversedUsers.length &&
          reversedUsers.map(user => {
            return (
              <UserAvatarWrapper key={`user-avatar-${user.id}`}>
                <Avatar img={user.avatar_url} />
              </UserAvatarWrapper>
            );
          })}
        {systemOwner && (
          <UserAvatarWrapper key={`user-avatar-${systemOwner.id}`}>
            <Avatar img={systemOwner.avatar_url} systemOwner={true} />
          </UserAvatarWrapper>
        )}
      </UsersAvatarsBlock>
    </UsersBlockWrapper>
  );
};

export default UsersBlock;
